import React, { useEffect } from 'react'
import { PageWrapper } from '../../Styles/style'
import Aos from "aos";
import "aos/dist/aos.css";
import S1_About from './S1_About';
import S2_Contributors from './S2_Contributors';
const About = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 });
        window.addEventListener("load", function () {
            Aos.init();
        });
    }, []);
    return (
        <div>
            <PageWrapper>
                <S1_About />
                <S2_Contributors />

            </PageWrapper>
        </div>
    )
}

export default About